import React from "react";
import { Table, TableBody, TableContainer } from "@mui/material";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { complainDuplicatesTableHead } from "../../../app/config";
import { ComplainDuplicatesTableFilter, ComplainsTableRow, TableHeader, TablePagination } from "../../../components/table";

function ComplainDuplicateList({ 
    parentId, 
    data, // renamed from complains to data to be consistent
    filter, 
    selectedItems, 
    onRequestSort, 
    onRowCheck, 
    onSelectAll, 
    onPreviousPage, 
    onNextPage,
    hasPrevious,
    hasNext 
}) {
    const [open, setOpen] = React.useState(null);
    const { t } = useTranslation('ComplainDuplicatesList');

    const handleRowClick = (id) => setOpen(open ? null : id);

    return (
        <div className="fk-company-complains-list">
            <ComplainDuplicatesTableFilter hideTitle hideSearch parentId={parentId} listTitle={t('title')} />
            <TableContainer>
                <Table size="medium" className="fk-table">
                    <TableHeader
                        crud
                        withCheckbox
                        items={complainDuplicatesTableHead}
                        orderBy={filter.orderBy}
                        order={filter.orderDirection}
                        numSelected={selectedItems.length}
                        rowCount={data.length}
                        onRequestSort={onRequestSort}
                        onSelectAllClick={onSelectAll}
                        screen="ComplainsScreen"
                    />
                    <TableBody>
                    {data.map((complain) => {
                        const isChecked = _.some(selectedItems, (item) => item.id === complain.id);

                        return (
                            <ComplainsTableRow
                                key={complain.id}
                                checked={isChecked}
                                open={open === complain.id}
                                complain={complain}
                                columns={complainDuplicatesTableHead}
                                onCheck={() => onRowCheck(complain, isChecked)}
                                onRowClick={handleRowClick}
                            />
                        )
                    })}
                    </TableBody>
                </Table>
                {data.length === 0 &&
                    <p className="fk-no-items">
                        {t('noRecords')}
                    </p>
                }
            </TableContainer>
            <TablePagination
                filter={filter}
                hasPrevious={hasPrevious}
                hasNext={hasNext}
                handlePreviousPage={onPreviousPage}
                handleNextPage={onNextPage}
            />
        </div>
    );
}

export default ComplainDuplicateList;
